// extracted by mini-css-extract-plugin
module.exports = {"spinnerMainContainer":"styles_spinnerMainContainer__WMoxO"};